import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { setCookie } from './util_03_cookie';
import { isWX, isMQQ, isFudaoApp, getAppVersion } from './util_04_ua';
import { weiXinApply } from './util_11_wx';
import { openAppPage } from './util_15_app';
/**
 * getBitMapValue
 * @memberof module:imutils
 * @param {number} v
 * @param {Array} map
 * @returns {string}
 * @example
 * imutils.getBitMapValue(2,[1,2,3,4]) => [2]
 */

function getBitMapValue(v, map) {
  var ret = [];
  var val;

  if (!map || !map.length) {
    return ret;
  }

  for (var i = map.length - 1; i > -1; --i) {
    // 相关讨论见这里 https://github.com/airbnb/javascript/issues/1392
    // eslint-disable-next-line
    val = Math.pow(2, i);

    if (v >= val) {
      ret.unshift(map[i]);
      v -= val;
    }
  }

  return ret;
}
/**
 * 根据传入的text生成tips
 * @memberof module:imutils
 * @param {string} text 需要生成tips的text
 * @param {object} object 传入的选项
 * @param {string} object.className - 传入的calssName
 */


function showTips(text) {
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _opt$className = opt.className,
      className = _opt$className === void 0 ? '' : _opt$className;
  var div = document.createElement('div');
  div.className = "util_tips ".concat(className);
  div.style.cssText = 'position: fixed; left: 4px; right: 4px; bottom: 60px; text-align: center; z-index: 100;';
  div.style.opacity = '0';
  var textDiv = document.createElement('div');
  textDiv.className = "util_tips_text ".concat(className);
  textDiv.innerText = text;
  textDiv.style.cssText = "display: inline-block;\n    text-align: left;\n    padding: 5px 10px;\n    background-color: rgba(0,0,0,0.4);\n    color: #fff;\n    border-radius: 6px;";
  div.appendChild(textDiv);
  document.body.appendChild(div); // eslint-disable-next-line

  appear();

  function appear() {
    var pointer = setInterval(function () {
      var op = Math.round(+div.style.opacity * 10) / 10;

      if (op === 1) {
        clearInterval(pointer);
        setTimeout(function () {
          // eslint-disable-next-line
          disappear();
        }, opt.timeout || 2000);
      } else {
        div.style.opacity = String(op + 0.1);
      }
    }, 20);
  }

  function disappear() {
    var pointer = setInterval(function () {
      var op = Math.round(+div.style.opacity * 10) / 10;

      if (op === 0) {
        clearInterval(pointer);

        if (div && document.body.contains(div)) {
          document.body.removeChild(div);
        }
      } else {
        div.style.opacity = String(op - 0.1);
      }
    }, 20);
  }

  var reg = /null|undefined/;

  if (reg.test(text) && window.BJ_REPORT) {
    window.BJ_REPORT.error("[bad tips] ".concat(text));
  }
}
/**
 * 隐藏Tips
 * @memberof module:imutils
 */


function hideTips() {
  _toConsumableArray(document.querySelectorAll('.util_tips')).forEach(function (tipsDom) {
    if (tipsDom && document.body.contains(tipsDom)) {
      document.body.removeChild(tipsDom);
    }
  });
}
/**
 * 显示顶部的tips
 * @param {string} text 需要在顶部显示的text
 * @memberof module:imutils
 */


function showTopTips(text) {
  var div = document.createElement('div');
  div.className = 'top-tips';
  div.innerHTML = text;
  div.style.cssText = 'width:100%; height: 24px; text-align:center; background-color: #f6f6cc; line-height: 24px;';
  document.body.insertBefore(div, document.body.firstChild);
}
/**
 * 设置name为plCache的Cookie
 * @memberof module:imutils
 * @ignore
 */

/* istanbul ignore next */


function setPlCache(pl) {
  // pagelocation cache
  setCookie({
    name: 'plCache',
    value: pl
  });
}
/**
 * 比较版本号
 * @memberof module:imutils
 * @param {string} ver1 版本1
 * @param {string} ver2 版本2
 * @returns {bool} 如果版本1大于版本2则为true，否则返回false
 */


function versionfunegt(ver1, ver2) {
  var version1pre = parseFloat(ver1);
  var version2pre = parseFloat(ver2);
  var version1next = Number(ver1.replace("".concat(version1pre, "."), ''));
  var version2next = Number(ver2.replace("".concat(version2pre, "."), ''));

  if (version1pre > version2pre) {
    return true;
  }

  if (version1pre < version2pre) {
    return false;
  }

  if (version1next >= version2next) {
    return true;
  }

  return false;
}
/**
 * 获取ImgUrl
 * @memberof module:imutils
 * @param {string} url 需要获取Img的URl
 * @return {string} ImgUrl
 * @example
 * imutils.getImgUrl('https://test.png') => //test.png
 */


function getImgUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return url.replace(/^https?:/, '');
}
/**
 * 根据cid获取课程的URl
 * @param {number | string } cid
 * @memberof module:imutils
 * @return {string} 当前cid的课程Url
 * @TODO 删去
 */

/* istanbul ignore next */


function getCourseUrl(cid) {
  var protocol = 'https:';

  if (typeof window.location !== 'undefined') {
    protocol = window.location.protocol;
  }

  return "".concat(protocol, "//fudao.qq.com/course.html?_bid=2379&overlay=1&course_id=").concat(cid);
}
/* istanbul ignore next */

/**
 * 获取老师的Url
 * @param {number | string } tid
 * @memberof module:imutils
 * @return {string} 老师的Url
 */


function getTeacherUrl(tid) {
  var protocol = 'https:';

  if (typeof window.location !== 'undefined') {
    protocol = window.location.protocol;
  }

  return "".concat(protocol, "//fudao.qq.com/teacher.html?_bid=2379&tid=").concat(tid);
}

var last = Date.now();
/**
 * 点击锁定？
 * @param {function} callback 回调函数
 * @memberof module:imutils
 */

function clickLock(callback) {
  var now = Date.now();

  if (now - last > 1000) {
    callback();
  }

  last = now;
}
/**
 * @memberof module:imutils
 * @ignore
 */

/* istanbul ignore next */


var photoProgress = {
  hasAddEventListener: false,
  onPhotoProgressCbs: {},
  on: function on(name, fn) {
    var onPhotoProgressCbs = this.onPhotoProgressCbs;

    if (!onPhotoProgressCbs[name]) {
      onPhotoProgressCbs[name] = fn;
    } else {
      if (typeof onPhotoProgressCbs[name] === 'function') {
        onPhotoProgressCbs[name] = [onPhotoProgressCbs[name]];
      }

      onPhotoProgressCbs[name].push(fn);
    }

    if (!this.hasAddEventListener && window.mqq) {
      this.hasAddEventListener = true;
      window.mqq.addEventListener('photoProgress', function (data) {
        Object.keys(onPhotoProgressCbs).forEach(function (fnName) {
          if (typeof onPhotoProgressCbs[fnName] === 'function') {
            onPhotoProgressCbs[fnName](data);
          } else {
            onPhotoProgressCbs[fnName].forEach(function (f) {
              f(data);
            });
          }
        });
      });
    }
  },
  off: function off(name) {
    delete this.onPhotoProgressCbs[name];
  }
};
/* istanbul ignore next */

/**
 * 设置分享的信息
 * @memberof module:imutils
 * @param {string} title 标题
 * @param {string} desc 描述
 * @param {string} link 链接
 * @param {string} imgUrl 图片地址
 */

function setShareInfomation(title, desc, link, imgUrl) {
  var opt = {
    title: title,
    desc: desc,
    link: link,
    imgUrl: imgUrl
  };

  if (isWX()) {
    var s;

    if (typeof wx === 'undefined') {
      s = document.createElement('script');
      s.setAttribute('src', '//res.wx.qq.com/open/js/jweixin-1.0.0.js');
      document.head.appendChild(s);
    }

    s.onload = function () {
      if (window.wx) {
        var _window = window,
            _wx = _window.wx;

        _wx.config({
          debug: false,
          appId: 'wx90cb6dfbfe2d68df',
          timestamp: new Date().getTime(),
          nonceStr: 'fuckTheNoncestr',
          signature: 'k12',
          jsApiList: ['ready', 'onMenuShareAppMessage']
        });

        _wx.ready(function () {
          _wx.onMenuShareAppMessage(opt);

          _wx.onMenuShareTimeline(opt);

          _wx.onMenuShareQQ(opt);

          _wx.onMenuShareQZone(opt);
        });
      }
    };
  } else if (isMQQ()) {
    if (window.mqq) {
      window.mqq.data.setShareInfo(opt);
    }
  }
}

var lastNetworkType;
/* istanbul ignore next */

/**
 * 微信和APP里获取网络类型
 * @memberof module:imutils
 * @param {string} callback异步回调函数
 * @return {string} 网络类型：'', 'wifi', '2G', '3G', '4G'
 */

function getNetworkType(cb) {
  var callback = function callback(res) {
    var resArr = ['', 'wifi', '2g', '3g', '4g', 'cable'];
    lastNetworkType = resArr[res] || '';
    cb(lastNetworkType);
  };

  if (typeof lastNetworkType === 'undefined') {
    // 如果是微信的话
    if (isWX()) {
      weiXinApply(function () {
        window.WeixinJSBridge.invoke('getNetworkType', {}, function (res) {
          lastNetworkType = '';

          switch (res.err_msg) {
            case 'network_type:edge':
              lastNetworkType = '2g';
              break;

            case 'network_type:wwan':
              lastNetworkType = '3g';
              break;

            case 'network_type:wifi':
              lastNetworkType = 'wifi';
              break;
            // case: 'fail': lastNetworkType = -1;

            default:
              break;
          }

          cb(lastNetworkType);
        });
      });
    } else if (isFudaoApp() && window.mqq) {
      window.mqq.invoke('edu', 'getNetworkType', callback);
    } else if (isMQQ() && window.mqq) {
      window.mqq.device.getNetworkInfo(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        callback(res.type);
      });
    } else {
      lastNetworkType = '';
      cb(lastNetworkType);
    }
  } else {
    cb(lastNetworkType);
  }
}

var NEW = 'new';
var SELF = 'self';
/* istanbul ignore next */

/**
 * 各种环境下打开页面
 * @memberof module:imutils
 * @param {string} url 需要打开的页面链接
 * @param {object} obj 可选参数 当前只支持属性target：'new' - 新开窗口（默认）, 'self' - 替换当前窗口
 * @reurn {void}
*/

function openUrl(url) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _window2 = window,
      mqq = _window2.mqq,
      location = _window2.location;
  var _params = params,
      _params$target = _params.target,
      target = _params$target === void 0 ? NEW : _params$target;
  /* istanbul ignore next */

  if (isFudaoApp()) {
    params = {
      url: encodeURIComponent(url)
    };

    if (target === SELF) {
      // ios 2.2不用调closepPage关闭当前页，调openAppPage的时候传removecnt: 1，会在进入下个页面的时候帮关闭当前页
      if (mqq.android || mqq.iOS && getAppVersion() < 17) {
        mqq.invoke('edu', 'closePage');
      } else {
        params.removecnt = 1;
      }
    }

    openAppPage('webview', params);
  } else if (+mqq.QQVersion !== 0) {
    mqq.ui.openUrl({
      url: url,
      target: target === NEW ? 1 : 0
    });
  } else if (target === SELF) {
    location.replace(url);
  } else {
    location.href = url;
  }
}

export { getBitMapValue, showTips, hideTips, showTopTips, setPlCache, versionfunegt, getImgUrl, getCourseUrl, getTeacherUrl, clickLock, photoProgress, setShareInfomation, getNetworkType, openUrl };